import logo from '../dip-logo.png';
import {CalendarMonth, Facebook, Instagram, LocalAtm, YouTube} from "@mui/icons-material";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Button,
    Grid,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemText,
    Snackbar,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";
import React, {useState, useEffect} from "react";
import ReactGA from "react-ga4";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import { InstagramEmbed, YouTubeEmbed } from 'react-social-media-embed';
import { Helmet } from 'react-helmet';
import partyImage from '../rodeojuliet2.jpg';

export const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const monNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const dateToHumanDateStr = dateObj => dayNames[dateObj.getDay()] + " " + monNames[dateObj.getMonth()] + " " + dateObj.getDate() + " " + dateObj.getHours() % 12 + "pm";

export default function Home() {
  let [lessons, setLessons] = useState([]);
  let [alert, setAlert] = useState(null)

  var maxAge = new Date();
  maxAge.setDate(maxAge.getDate() - 14)

  useEffect(() => {
      const fetchCalendar = async() => {
          const url = "https://nzrxe9e4a4.execute-api.us-east-1.amazonaws.com/calendar";
          const cal = await fetch(url)
              .then(res => res.json())
              .then(lessons => lessons.filter((lesson) => new Date(lesson.start).getTime() > maxAge.getTime()))
              .then(lessons => setLessons(lessons))
      }

      fetchCalendar()
  }, [])

  ReactGA.initialize('G-F9YPQWKTFP');
  ReactGA.event({
      category: 'View',
      action: 'Home Page',
      label: 'Home Page Loaded'
  });

  const subscribe = async () => {
      const url = "https://neon2step.us17.list-manage.com/subscribe/post-json?u=903830d4195eb4152596b273e&amp;id=15bcec96b8&amp;f_id=007b7ce0f0&EMAIL=caguru%40gmail.com&c=__jp0"
      const params =  new URLSearchParams({
          EMAIL: document.getElementById('sub_email').value,
          FNAME: document.getElementById('sub_fname').value,
          LNAME: document.getElementById('sub_lname').value
      });

      await fetch(url, {
          method: "POST",
          mode: "no-cors",
          body: encodeURI(params)
      })
      .then(res => {
          if (res.status == 200) {
              alert("hw")
              setAlert({status: 200, msg: res.text()})
          }
      })

      return;
  }

  return (
      <div className="App">
        <Helmet>
            <title>Neon 2 Step Honky Tonk Dance Lessons</title>
            <meta name="description" content="Directions and parking information for Tim's place in Austin, TX." />
        </Helmet>
          <Snackbar
              open={alert}
              autoHideDuration={3000}
              message=""
          />
          <div style={{margin: "auto", textAlign: "center", marginTop:"40px"}}>
              <Box sx={{ borderRadius: '5px' }}>
                 <img src={logo} className="App-logo" alt="logo" />
              </Box>
          </div>

          <Grid container className={"content"} spacing={2}>
                <Grid item sm={12}>
                    <Card>
                        <CardHeader title={"90s 2-Step and Cha Cha Party"} />
                        <CardContent>
                            <img src={partyImage} alt="90s 2-Step and Cha Cha Party" style={{width: "300px", borderRadius: "5px", margin: "16px", float: "right"}} />
                            <Typography mb={2} variant="body1">Get ready for a night of classic honky tonk fun!</Typography>
                            <Typography mb={2} variant="body1">You know who misses traditional honky tonk dancing? I do! Thanks to ABGB this is now gonna be a reality.</Typography>
                            <Typography mb={2} variant="body1">What are we gonna cover? First, a Texas style traveling 2-step lesson and how to address common issues for those that are familiar with swingy 2-step, and how to dance in traffic.</Typography>
                            <Typography mb={2} variant="body1">Also gonna do a cowboy cha-cha crash course. I can’t stress how much this dance will add to your dancing life.</Typography>
                            <Typography mb={2} variant="body1">Then the real fun begins when Rodeo and Juliet Band takes the stage. Not only is this band top notch, they play a lot of songs just for these dances. This will be the best chance to practice these styles to live music in a very long time.</Typography>
                            <Typography mb={2} variant="body1">All are welcome!</Typography>
                            <Typography mb={2} variant="body1">No cover / pay what you can. The band is doing us a HUGE favor on this so please consider donating $10 per person.</Typography>
                            <Typography mb={2} variant="body1">Lesson @ 7, band shortly after 8</Typography>
                            <Typography mb={2} variant="body1">📍 ABGB, 1305 W Oltorf St, Austin, TX 78704</Typography>
                        </CardContent>
                        <CardActions>
                            <Button 
                                sx={{ m: 2 }}
                                size="medium" 
                                color="primary"
                                variant="contained"
                                href="https://partiful.com/e/YV8bGAyEiAp2IXjvY2d8"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                RSVP Appreciated
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                
                <Grid item sm={12}>
                    <h4>Where to Dance</h4>
                    Check out the <Link href={"https://austin2step.com"}>Austin 2 Step Calendar</Link> for a full list of all the best places to dance.
                </Grid>
                <Grid item sm={12}>
                    <h4>Services</h4>
                    <div>
                        <p>Private Lessons, Group Lessons, and Workshops available.</p>
                    </div>
                </Grid>
                <Grid item sm={12}>
                    <Box sx={{width: "450px"}}>
                    <LiteYouTubeEmbed
                        id="_sCEWExefXY"
                        title="Polka in the Park with Neon 2-Step"
                    />
                    </Box>
                </Grid>
                <Grid item sm={12}>
                    <Box sx={{width: "450px"}}>
                        <LiteYouTubeEmbed
                            id="-p4ohR1EZo8"
                            title="Howlin Blues Party"
                        />
                    </Box>
                </Grid>
          </Grid>

          <div className="FooterStripe">
                      <IconButton href={"https://www.facebook.com/neon2step"}
                                  aria-label="Neon 2 Step Facebook Page"><Facebook/></IconButton>
                      <IconButton href={"https://www.instagram.com/neon2step"}><Instagram/></IconButton>
                      <IconButton href={"https://www.venmo.com/timplode"}><LocalAtm/></IconButton>
                    <Button size="small" id="whereToTwoStep" href={"https://austin2step.com"} variant={"contained"}><span style={{fontFamily: "arial", fontWeight:900, fontSize:"70%"}}>WHERE TO 2-STEP </span> <CalendarMonth/></Button>
          </div>
    </div>
  );
}